import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cartReduce",
  "use": "icon-cartReduce-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cartReduce\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.75 14C5.75 13.3096 6.30964 12.75 7 12.75L21 12.75C21.6904 12.75 22.25 13.3096 22.25 14C22.25 14.6904 21.6904 15.25 21 15.25L7 15.25C6.30964 15.25 5.75 14.6904 5.75 14Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol